import React from 'react';
import type { ChangeEvent } from 'react';
import type { TravelerFormValues } from '../../../../api/reservationInfo';
import type { TravelerFieldRules } from '../utils';

type Props = {
  travelerFieldRules: TravelerFieldRules;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
};

const ReservationInfoAirBirthdayField = ({
  travelerFieldRules,
  traveler,
  travelerErrors,
  onTextChange,
  disabled
}: Props) => {
  const { isRequired, isVisible } = travelerFieldRules;
  if (!isVisible('flight_birthday')) return null;
  const styles = getStyles();

  return (
    <div style={styles.formGroup}>
      <label htmlFor="traveler-flightBirthday" style={styles.label}>
        生年月日
        {isRequired('flight_birthday') && <span style={styles.required}>*</span>}
      </label>
      <input
        id="traveler-flightBirthday"
        type="date"
        style={{
          ...styles.input,
          ...(travelerErrors.flightBirthday ? styles.inputError : {})
        }}
        value={traveler.flightBirthday}
        onChange={onTextChange('flightBirthday')}
        disabled={disabled}
      />
      {travelerErrors.flightBirthday && <span style={styles.errorText}>{travelerErrors.flightBirthday}</span>}
    </div>
  );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '6px',
    color: '#333'
  },
  required: {
    color: '#e74c3c',
    marginLeft: '4px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxSizing: 'border-box' as const,
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  }
});

export default ReservationInfoAirBirthdayField;
